import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertTriangle, FiLock, FiArrowRight } = FiIcons;

function NoticeSection() {
  return (
    <div className="bg-yellow-50 border-t border-yellow-200 py-8">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-lg p-6 shadow-sm border border-yellow-200">
          <div className="flex items-start space-x-3 mb-4">
            <SafeIcon icon={FiAlertTriangle} className="text-yellow-600 text-xl mt-1 flex-shrink-0" />
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-3">Notice</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
              </p>
              <div className="flex items-start space-x-3 mb-4">
                <SafeIcon icon={FiLock} className="text-green-600 text-lg mt-1 flex-shrink-0" />
                <p className="text-gray-700 text-sm leading-relaxed">
                  We never share any client website made under this offer with others – your project privacy is 100% safe.
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiArrowRight} className="text-blue-600" />
                <a 
                  href="https://projects.azaansuperpc.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 font-medium text-sm transition-colors"
                >
                  Check Offer
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoticeSection;